import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ENVIRONMENT_INITIALIZER, inject, NgModule } from '@angular/core';

import { AnalyticsService } from './analytics.service';
import { HttpErrorInterceptor } from './http-error.interceptor';

@NgModule({
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    // AnalyticsService is now provided in root via @Injectable({ providedIn: 'root' })
    // Keep ENVIRONMENT_INITIALIZER to ensure service is instantiated at app startup
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(AnalyticsService),
      multi: true,
    },
  ],
})
export class AnalyticsModule {}
